const initialState = {
  data: [],
};

const tablicaCzynszeReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TABLICA_CZYNSZE':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default tablicaCzynszeReducer;